// const GA = require('vue-ga').default;
// TODO: [Sportybet]
import GA from '@/common/lib/vue-ga';
declare const window: any;
declare const GLOBAL_ENABLE_GA: boolean;
const disableGA = !GLOBAL_ENABLE_GA;
// const disableGA = false;

const actions = {
  RESOLVED: 'Resolved',
  NOT_RESOLVED: 'Not Resolved',
  LIVE_CHAT: 'Live Chat',
  CREATED_TICKET: 'Create Ticket',
  CALL: 'Call',
};

export const registerGA = (router: any) => {
  if (disableGA) return;
  GA(router, 'UA-113009458-4');
};

// send, event, category, action,
export const analytics = {
  chatArticle: (data: {
    title: string,
    articleId: string
  }) => {
    if (disableGA) return;
    window.ga && window.ga('send', 'event', 'Chat_Article', data.title, data.articleId);
  },
  resolveIssue: () => {
    if (disableGA) return;
    window.ga && window.ga('send', 'event', 'Click', actions.RESOLVED);
  },
  notResolveIssue: () => {
    if (disableGA) return;
    window.ga && window.ga('send', 'event', 'Click', actions.NOT_RESOLVED);
  },
  liveChat: () => {
    if (disableGA) return;
    window.ga && window.ga('send', 'event', 'Click', actions.LIVE_CHAT);
  },
  createTicket: () => {
    if (disableGA) return;
    window.ga && window.ga('send', 'event', 'Click', actions.CREATED_TICKET);
  },
  call: () => {
    if (disableGA) return;
    window.ga && window.ga('send', 'event', 'Click', actions.CALL);
  },
};
